import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import getFormattedValues, { formatReceived } from 'utils/formatValues';

export const baseURI = 'empresas/obligaciones-fiscales/';

/**
 * GET Obligaciones Fiscales
 * @param {Object} params
 * @returns {Promise<Array<object>>}
 */
export const getObligacionesFiscales = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Obligacion Fiscal
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getObligacionFiscal = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Obligacion Fiscal
  * @param {object} values
  * @returns {Promise<object|boolean>}
 */
export const postObligacionFiscal = async (values) => {
  try {
    const response = await API.post(baseURI, getFormattedValues(values));
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Obligacion Fiscal
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchObligacionFiscal = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, getFormattedValues(values));
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};
/**
 * DELETE Obligacion Fiscal
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteObligacionFiscal = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}/`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
